import styled from 'styled-components';

import {colors, font} from '../../../../../theme';

export const BodyElement = styled.div<{dataMutualIndex?: number}>`
    position: relative;
    display: flex;
    box-sizing: border-box;
    padding: 8px 16px;

    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;

    &.allowances {
        &:after {
            position: absolute;
            right: 0;
            width: 1px;
            height: 18px;
            background: ${colors.textMuted};
            content: '';
        }
    }

    &.charges {
        &:after {
            position: absolute;
            right: 0;
            width: 1px;
            height: 18px;
            background: ${colors.textMuted};
            content: '';
        }
    }
`;
export const GroupName = styled.span`
    display: inline-flex;
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: ${colors.brandPrimary};
`;
